module.exports = __webpack_public_path__ + "img/mail.e5314dab.svg";